import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IVw_Members {
member_id:number,
member_name:string,
mobile_number:string,
email:string,
age:number,
blood_group_id:number,
blood_grp_name?:string,
desig_level_id:number,
desig_level_name?:string,
designation_id:number,
designation_name?:string,
address:string,
pincode:string,
vibhag_id:number,
vibhag_name?:string,
zill_id:number,
zilla_name?:string,
nagar_khanda_id:number,
nagar_khanda_name?:string,
login_otp:number,
last_logged_in:Date,
is_active:boolean,
created_on:Date,
modified_on:Date
}

interface IVw_MembersData {
    list?: Array<IVw_Members>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: IVw_MembersData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const vw_membersSlice = createSlice({
    name: "vw_members",
    initialState,
    reducers: {
        setVw_MembersList: (state, _action: PayloadAction<IVw_MembersData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetVw_MembersToInit: (state) => {
            state = initialState;
        },
        setVw_MembersMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setVw_MembersList, resetVw_MembersToInit, setVw_MembersMessage } = vw_membersSlice.actions;

export default vw_membersSlice.reducer;

